export default __webpack_public_path__ + "static/media/milky-way.10650639.jpg";